$(document).ready(function () {
    let menu, menuItems, menuItemsActiveClass, submenu, submenuItems, submenuActiveClass, submenuItemsActiveClass,
        inAction, animationDuration, toggleTimeout;
    if ($(window).width() < 768) return;

    menu = $('.header .menu');
    menuItems = menu.find('.menu__item');
    menuItemsActiveClass = 'link_decorated-active';
    submenu = $('.header .submenu');
    submenuItems = submenu.find('.submenu__item');
    submenuActiveClass = 'submenu_active';
    submenuItemsActiveClass = 'submenu__item_active';
    inAction = false;
    animationDuration = 350;

    const toggleAction = () => {

        inAction = true;
        setTimeout(() => inAction = false, animationDuration);

    };

    const animateHeight = height => {
        submenu.stop().animate({
            height: height
        }, animationDuration);
    };

    const closeMenu = () => {

        if (inAction || !$('.' + submenuItemsActiveClass).length) return;

        toggleAction();
        menuItems.children().removeClass(menuItemsActiveClass);
        submenuItems.removeClass(submenuItemsActiveClass);
        animateHeight(0);
    };

    const checkMove = e => {
        const target = $(e.target);
        if (!target.parents('.header__item').length && !target.hasClass('header__item'))
            closeMenu();
    };

    menuItems.on('mouseenter', function () {
        const item = $(this),
            index = item.index();

        if (!submenuItems.eq(index).length) {
            closeMenu();
            return;
        }

        if (!submenu.hasClass(submenuActiveClass)) {
            animateHeight(submenuItems.get(index).scrollHeight);
            toggleAction();
        }

        menuItems.children().removeClass(menuItemsActiveClass);
        item.children().addClass(menuItemsActiveClass);
        submenuItems.removeClass(submenuItemsActiveClass);
        submenuItems.eq(index).addClass(submenuItemsActiveClass);

    });

    $('body').on('mouseleave', closeMenu);
    $(document).on('mousemove', checkMove);

});